import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const DEFAULT_SETTINGS = {
  business_name: "RD Cleaning Services",
  phone: "[PHONE NUMBER]",
  email: "[EMAIL ADDRESS]",
  service_area: "Perth, Western Australia",
  google_review_url: "",
  abn: "",
};

const SiteContext = createContext({ settings: DEFAULT_SETTINGS, areas: [], testimonials: [] });

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [areas, setAreas] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/content/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/content/service-areas").then((r) => setAreas(r.data)).catch(() => {});
    api.get("/content/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);

  return (
    <SiteContext.Provider value={{ settings, areas, testimonials }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
